import React from 'react'
import HeroImage from "../assets/contact.jpg"
import ContactComp from '../components/ContactComp'
import HeroComp from '../components/HeroComp'

export default function Contact() {
  return (
    <>
            <HeroComp heading="Contact Us" paragraph="Heyy... I'm Hammad Khan. Feel Free to Contact me i am very Responsive" src={HeroImage}/>
            <ContactComp />
    </>
  )
}
